module.exports = __webpack_public_path__ + "static/media/partners-image-11.70f4e04d.svg";